import { getUniqueString as e } from "../../common/utils/index.js";
import { t } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { createCommentVNode as n, createElementBlock as r, createTextVNode as i, normalizeClass as a, openBlock as o, renderSlot as s, toDisplayString as c } from "vue";
//#region components/list_item_group/list_item_group.vue
var l = {
	compatConfig: { MODE: 3 },
	name: "DtListItemGroup",
	props: {
		id: {
			type: String,
			default() {
				return e();
			}
		},
		heading: {
			type: String,
			default: ""
		},
		headingClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		listClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		}
	}
}, u = ["id", "aria-labelledby"], d = ["id"];
function f(e, t, l, f, p, m) {
	return o(), r("ul", {
		id: l.id,
		class: a(["d-list-item-group", l.listClass]),
		role: "group",
		"data-qa": "dt-dropdown-list-wrapper",
		"aria-labelledby": `${l.id}-heading`
	}, [l.heading ? (o(), r("li", {
		key: 0,
		id: `${l.id}-heading`,
		role: "presentation",
		"data-qa": "dt-dropdown-list-heading",
		class: a(["dt-dropdown-list--header", l.headingClass])
	}, [s(e.$slots, "heading", {}, () => [i(c(l.heading), 1)])], 10, d)) : n("", !0), s(e.$slots, "default")], 10, u);
}
var p = /* @__PURE__ */ t(l, [["render", f]]);
//#endregion
export { p as default };

//# sourceMappingURL=list-item-group.js.map